import { getConfig } from 'modules/App/config';
import buildBaseIdsQuery from 'modules/App/queries/buildBaseIdsQuery';
import buildFiltersQuery, {
  baseDocumentSort,
} from 'modules/Documents/helpers/buildFiltersQuery';
import { buildTortillasSortQuery } from 'utils/query/buildTortillaBaseQuery';
import request from 'utils/request';

import { DocumentFilters, DocumentSort } from '../../models/document';

interface ScanBulkDocumentsParams {
  ids: string[];
  excludeIds: boolean;
  filters?: DocumentFilters;
  sortBy?: DocumentSort;
}

const scanBulkDocuments = async ({
  excludeIds,
  ids = [],
  filters,
  sortBy,
}: ScanBulkDocumentsParams) => {
  const endpoint = `${(await getConfig()).apiDocumentScanService}/bulk-scan`;

  let query = buildTortillasSortQuery(baseDocumentSort(sortBy));
  query += buildBaseIdsQuery(ids, excludeIds);

  if (excludeIds && filters) {
    query += buildFiltersQuery(filters);
  }

  const response = await request<{ data: { taskId: string } }>(
    `${endpoint}?${query}`,
    {
      method: 'POST',
    }
  );

  if (response.status < 200 || response.status >= 400) {
    throw new Error('Error descargando excel');
  }

  return response.data.data;
};

export default scanBulkDocuments;
